// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__32LHm","checkboxCol":"Table_checkboxCol__18Ixv","emailCol":"Table_emailCol__2SKXf","actionCol":"Table_actionCol__2jDLY"};